import Vue from 'vue'
import Main from '../components/main.vue';
import Index from '../components/index/index.vue'; // 首页
import Enroll from '../components/account/enroll.vue'; // 环境归一：注册页面
import LoginPage from '../components/account/log-in.vue'; // 环境归一：登录
import Bind from '../components/account/bind.vue'; // 环境归一：绑定沙箱账号页面
import Password from '../components/account/password.vue'; // 密码
import Personage from '../components/account/personage.vue'; // 个人信息
import AgreementService from '../components/agreement/service.vue'; // 服务协议
import GenericDoc from '../components/doc/generic-doc'; // 接入流程
import ApiDoc from '../components/doc/api.vue'; // api文档
import ControlIndex from '../components/control/index.vue'; // 我的应用
import messageIndex from '../components/message/index.vue'; // 通知中心
import messageDetail from '../components/message/detail.vue'; // 通知详情
import ControlApp from '../components/control/app/app.vue'; // 应用管理-公共
import ControlAppInfo from '../components/control/app/info.vue'; // 应用管理-基本信息
import ControlAppVoucher from '../components/control/app/voucher.vue'; // 应用管理-证书信息
import ControlAppFlow from '../components/control/app/flow.vue'; // 应用管理-流量控制
import ControlAppAuth from '../components/control/app/auth.vue'; // 应用管理-授权信息
import ControlEpAuth from '../components/control/ep-auth.vue'; // 我的应用-用户授权
import Order from '../components/help/order.vue'; // 订单工具
import toolbox from '../components/help/toolbox.vue'; // 帮助中心首页
import HotTickets from '../components/ticket/hot-tickets.vue'; // 热门回答
import DocSearch from '../components/help/search.vue'; // 文档搜索

import Handbook from '../components/help/handbook.vue'; // 操作手册
import AddTicket from '../components/ticket/add.vue'; // 新增工单
import Tickets from '../components/ticket/tickets.vue'; // 工单列表
import TicketDetail from '../components/ticket/detail.vue'; // 工单详情
import ticketPage from '../components/help/ticket.vue';
import order from "../components/help/order";
import apiToolPage from "../components/help/apitool"; // API调试台
import walletToolPage from "../components/help/wallet"; //充值工具
import couponToolPage from "../components/help/coupon"; //发券工具
// 约定name必须且与组件内部定义的name属性相同，小驼峰。动态设置路由keep-alive时需要
export default [
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/',
        redirect: '/index'
      }, {
        path: '/index',
        name: 'index',
        component: Index,
        meta: {title: '货拉拉开放平台',}
      }, {
        path: '/enroll',
        name: 'enroll',
        component: Enroll,
        meta: {title: '注册',}
      },
      {
        path: '/bind',
        name: 'bind',
        component: Bind,
        meta: {title: '绑定',}
      },
      {
        path: '/log-in',
        name: 'log-in',
        component: LoginPage,
        meta: {title: '登录',}
      },
      {
        path: '/password',
        name: 'password',
        component: Password,
        meta: {title: '修改密码',}
      }, {
        path: '/personage',
        name: 'personage',
        component: Personage,
        meta: {title: '个人信息',}
      }, {
        path: '/agreement/service',
        name: 'agreementService',
        component: AgreementService,
        meta: {title: '货拉拉开放平台服务协议', userType: 2}
      }, {
        path: '/generic-doc/:id',
        name: 'genericDoc',
        component: GenericDoc,
        meta: {title: ''}
      }, {
        path: '/doc/api',
        name: 'docApi',
        component: ApiDoc,
        meta: {title: 'api文档'}
      }, {
        path: '/control/myapp',
        name: 'controlIndex',
        component: ControlIndex,
        meta: {title: '我的应用'}
      },{
        path: '/message/mymessage',
        name: 'messageIndex',
        component: messageIndex,
        meta: {title: '通知中心'}
      },{
        path: '/message/detail',
        name: 'messageDetail',
        component: messageDetail,
        meta: {title: '通知设置', crumbs: [{name: '通知中心', path: '/message/mymessage'}, {name: '通知详情'}]}
      },
      {
        path: '/help/handbook',
        name: 'handbook',
        component: Handbook,
        meta: {title: '操作手册'}
      }, {
        path: '/help/tickets',
        name: 'tickets',
        component: ticketPage,
      },{
        path: '/help/apitool',
        name: 'apitool',
        component: apiToolPage,
      },  {
        path: '/help/wallet',
        name: 'wallet',
        component: walletToolPage,
      },  {
        path: '/help/coupon',
        name: 'coupon',
        component: couponToolPage,
      },{
        path: '/help/tickets/hot',
        name: 'hotTickets',
        component: HotTickets,
      }, {
        path: '/help',
        name: 'toolbox',
        component: toolbox,
        meta: {title: '帮助中心'}
      }, {
        path: '/help/order',
        name: 'order',
        component: Order,
        meta: {title: '订单测试工具'}
      }, {
        path: '/help/search',
        name: 'docSearch',
        component: DocSearch,
        meta: {title: '搜索'}
      }, {
        path: '/help/ticket/list',
        name: 'ticketList',
        component: Tickets,
        meta: {title: '工单列表'}
      }, {
        path: '/help/ticket/detail/:ticketNo',
        name: 'ticketDetail',
        component: TicketDetail,
        meta: {title: '工单详情'}
      }, {
        path: '/help/ticket/add',
        name: 'addTicket',
        component: AddTicket,
        meta: {title: '新增工单'}
      }, {
        path: '/control/app',
        component: ControlApp,
        children: [
          {
            path: '/control/app/info/:appId',
            name: 'controlAppInfo',
            component: ControlAppInfo,
            meta: {title: '应用基本信息'}
          }, {
            path: '/control/app/voucher/:appId',
            name: 'controlAppVoucher',
            component: ControlAppVoucher,
            meta: {title: '应用证书信息'}
          }, {
            path: '/control/app/flow/:appId',
            name: 'controlAppFlow',
            component: ControlAppFlow,
            meta: {title: '应用流量控制'}
          }, {
            path: '/control/app/auth/:appId',
            name: 'ControlAppAuth',
            component: ControlAppAuth,
            meta: {title: '应用授权信息'}
          }
        ]
      }, {
        path: '/oauth/authorize',
        name: 'controlEpAuth',
        component: ControlEpAuth,
        meta: {title: '用户授权', userType: 2} // userType为2 不展示head菜单
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js